import { IProductCategory } from './product-category';
import { IProduct, IProductVariation } from './product.interface';

export enum PromotionTypeEnum {
  COUPON = 'COUPON',
  BUY1_GET1 = 'BUY1_GET1',
  BUYX_GETX = 'BUYX_GETX',
  PERCENTAGE_OFF = 'PERCENTAGE_OFF',
}

export enum PromotionDiscountTypeEnum {
  PERCENTAGE = 'PERCENTAGE',
  FIXED = 'FIXED',
}

export interface IPromotionCoupon {
  id: number;
  code: string;
  limitTimes: number;
  discountType: PromotionDiscountTypeEnum;
  discountValue: number;
  maxDiscountValue: number | null;
  threshold: number | null;
  limitPerUser: number;
  limitOnePerOrder: boolean;
  promotionId: number;
  createdAt: Date;
  updatedAt: Date;
  available?: boolean;
}

export interface IPromotionBuyXGetX {
  id: number;
  promotionId: number;
  buyX: number;
  getX: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface IPromotionPercentageOff {
  id: number;
  threshold: number;
  discountType: PromotionDiscountTypeEnum;
  discountValue: number;
  maxDiscountValue: number;
  /** จำนวนครั้งที่ใช้ได้ต่อคน — null คือไม่จำกัด */
  limitPerUser: number | null;
  /** จำนวนบิลทั้งหมดที่ใช้ได้ รวมทุกคน — null คือไม่จำกัด */
  limitTimes: number | null;
  /** จำนวนบิลที่ใช้ไปแล้ว รวมทุกคน */
  usedCount: number;
  /** จำนวนบิลที่จองไว้และกำลังรอผลชำระเงิน */
  reservedCount: number;
  /** tier ที่ถอดจากแคมเปญแล้วแต่เก็บไว้เพื่อ audit รายการเดิม */
  retiredAt: string | null;
  promotionId: number;
  createdAt: Date;
  updatedAt: Date;
}

/** หนึ่งแถวในตารางความเคลื่อนไหวงบประมาณบน Dashboard */
export interface IPromotionBudgetActivity {
  orderId: string;
  amountSpent: number;
  discountReserved?: number;
  discountApplied: number;
  remainingBudget: number | null;
  status?:
    | 'PENDING'
    | 'SETTLED'
    | 'REJECTED'
    | 'FAILED'
    | 'EXPIRED'
    | 'CANCELLED'
    | 'SETTLEMENT_CONFLICT'
    | 'REFUNDED';
  createdAt: string;
}

export interface IPromotionBudgetDashboard {
  promotion: { id: number; name: string } | null;
  budgetTotal: number | null;
  budgetSpent?: number | null;
  reservedBudget?: number | null;
  currentBudget: number | null;
  availableBudget?: number | null;
  recentActivities: IPromotionBudgetActivity[];
  page: number;
  limit: number;
  totalDocs: number;
  totalPages: number;
  prevPage: number | null;
  nextPage: number | null;
}

export interface IPromotionBudgetOption {
  id: number;
  name: string;
  active: boolean;
}

export interface IPromotion {
  id: number;
  type: PromotionTypeEnum;
  name: string;
  description?: string | null;
  startDate: Date;
  endDate: Date | null;
  active: boolean;
  /** งบประมาณที่เติมไว้ — null คือไม่จำกัดงบ */
  budgetTotal: number | null;
  /** ยอดส่วนลดที่จ่ายออกไปแล้ว; คงเหลือ = budgetTotal - budgetSpent */
  budgetSpent: number;
  /** ยอดที่กันไว้ระหว่างรอผลการชำระเงิน ไม่ใช่ยอดใช้จริง */
  budgetReserved: number;
  productIds: number[][] | null;
  productCategoryIds: number[][] | null;
  userIds: number[] | null;
  createdAt: Date;
  updatedAt: Date;
  createdById: number | null;
  updatedById: number | null;

  // relations
  coupons?: IPromotionCoupon[] | null;
  percentageOffs?: IPromotionPercentageOff[] | null;
  buyXGetX?: IPromotionBuyXGetX | null;
  productCategories?: IProductCategory[] | null;
  products?: IProduct[] | null;
  productVariations?: IProductVariation[] | null;
  users?: any[] | null;
}
